import { ExternalLink, Clock } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const timeAgo = (iso, lang) => {
  if (!iso) return "";
  const diff = Math.max(0, Date.now() - new Date(iso).getTime());
  const h = Math.floor(diff / 3600000);
  if (h < 1) { const m = Math.max(1, Math.floor(diff / 60000)); return lang === "fr" ? `il y a ${m} min` : `${m} min ago`; }
  if (h < 24) return lang === "fr" ? `il y a ${h} h` : `${h}h ago`;
  const d = Math.floor(h / 24);
  return lang === "fr" ? `il y a ${d} j` : `${d}d ago`;
};

export const ExternalNewsCard = ({ item, index, compact = false }) => {
  const { t, lang } = useLanguage();
  return (
    <a href={item.link} target="_blank" rel="noopener noreferrer" data-testid={`external-news-card-${index}`} className={`group flex overflow-hidden rounded-3xl border border-brand/10 bg-white transition-all duration-500 hover:-translate-y-1.5 hover:border-gold/40 hover:shadow-2xl hover:shadow-gold/10 ${compact ? "items-center gap-4 p-4" : "h-full flex-col"}`}>
      {item.image && (
        <div className={compact ? "h-16 w-24 shrink-0 overflow-hidden rounded-xl" : "aspect-[16/9] overflow-hidden"}>
          <img src={item.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        </div>
      )}
      <div className={compact ? "min-w-0 flex-1" : "flex flex-1 flex-col p-6"}>
        <div className="flex flex-wrap items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-brand">
          <span className="truncate">{item.source}</span><span>·</span>
          <span className="inline-flex items-center gap-1 normal-case tracking-normal text-brand-hover"><Clock className="h-3 w-3" />{timeAgo(item.published, lang)}</span>
        </div>
        <h3 className={`font-display mt-2 font-bold leading-snug text-forest transition-colors group-hover:text-gold ${compact ? "line-clamp-2 text-sm sm:text-base" : "text-base sm:text-lg"}`}>{item.title}</h3>
        {!compact && item.summary && <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-brand-hover">{item.summary}</p>}
        {!compact && <span className="mt-auto inline-flex items-center gap-2 pt-5 font-mono text-[11px] uppercase tracking-[0.2em] text-gold">{t.news.external.readOn}<ExternalLink className="h-3.5 w-3.5" /></span>}
      </div>
    </a>
  );
};
